module.exports = __webpack_public_path__ + "img/stock0.3f32c093.png";